module.exports = __webpack_public_path__ + "checkbox-01@2x.d5554fe41aed23e1e49f249f2f6bcfaa.png";